import login from './login';

export default {
  language: 'sk',
  country: 'sk',
  name: 'Slovenčina',
  embeddedLocale: login,
};
